import { render, staticRenderFns } from "./TrailEditor.vue?vue&type=template&id=4c417814&scoped=true"
import script from "./TrailEditor.vue?vue&type=script&lang=js"
export * from "./TrailEditor.vue?vue&type=script&lang=js"
import style0 from "./TrailEditor.vue?vue&type=style&index=0&id=4c417814&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c417814",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c417814')) {
      api.createRecord('4c417814', component.options)
    } else {
      api.reload('4c417814', component.options)
    }
    module.hot.accept("./TrailEditor.vue?vue&type=template&id=4c417814&scoped=true", function () {
      api.rerender('4c417814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/TrailEditor.vue"
export default component.exports